var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"docGenFrame",staticStyle:{"overflow":"auto","border":"1px ridge blue"},attrs:{"type":"text/html","src":_vm.url,"width":"100%","height":"100%"},on:{"load":_vm.onFrameLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }